import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Instructor } from '../modal/instructor';

export const deleteInstructorAPI = async (fieldId: string) => {
  const resp = await baseAPI.delete<Instructor>(`/custom-form/${fieldId}`);
  return resp.data;
};

export const useDeleteInstructorMutation = () => {
  return useMutation({
    mutationFn: async ({ fieldId }: { fieldId: string }) => {
      const response = await deleteInstructorAPI(fieldId);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.INSTRUCTORS,
      });
    },
  });
};
